module.exports = __webpack_public_path__ + "static/hero_bg-45685b3ad2a3bc508e14bb56d5863a52.jpg";